import { frontendURL } from '../../../helper/URLHelper';

const CrmDashboard = () => import('./pages/CrmDashboard.vue');
const CrmOrders = () => import('./pages/CrmOrders.vue');
const CrmOrderDetail = () => import('./pages/CrmOrderDetail.vue');
const CrmPipeline = () => import('./pages/CrmPipeline.vue');
const CrmCampaigns = () => import('./pages/CrmCampaigns.vue');
const CrmCampaignEdit = () => import('./pages/CrmCampaignEdit.vue');
const CrmCustomer360 = () => import('./pages/CrmCustomer360.vue');
const CrmProducts = () => import('./pages/CrmProducts.vue');
const CrmSettings = () => import('./pages/CrmSettings.vue');
const CrmSegments = () => import('./pages/CrmSegments.vue');
const CrmWhatsAppCampaigns = () => import('./pages/CrmWhatsAppCampaigns.vue');
const CrmWorkflows = () => import('./pages/CrmWorkflows.vue');
const CrmTemplates = () => import('./pages/CrmTemplates.vue');

const meta = {
  permissions: ['administrator', 'agent'],
};

export const crmRoutes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_dashboard',
    component: CrmDashboard,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/orders'),
    name: 'crm_orders',
    component: CrmOrders,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/orders/:orderId'),
    name: 'crm_order_detail',
    component: CrmOrderDetail,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/pipeline'),
    name: 'crm_pipeline',
    component: CrmPipeline,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/campaigns'),
    name: 'crm_campaigns',
    component: CrmCampaigns,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/campaigns/:campaignId'),
    name: 'crm_campaign_edit',
    component: CrmCampaignEdit,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/customer/:contactId'),
    name: 'crm_customer_360',
    component: CrmCustomer360,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/products'),
    name: 'crm_products',
    component: CrmProducts,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/segments'),
    name: 'crm_segments',
    component: CrmSegments,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/whatsapp'),
    name: 'crm_whatsapp_campaigns',
    component: CrmWhatsAppCampaigns,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/workflows'),
    name: 'crm_workflows',
    component: CrmWorkflows,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/templates'),
    name: 'crm_templates',
    component: CrmTemplates,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/crm/settings'),
    name: 'crm_settings',
    component: CrmSettings,
    meta: { permissions: ['administrator'] },
  },
];
